import { ElectronApi } from '@/services/electron.api';
import { textToMd5 } from '@/utils/md5.utils';

export const withTempFile = async (
  _base64: string,
  action: (filePath: string) => Promise<void>,
  clear = true,
  extension = 'png'
) => {
  try {
    const base64 = _base64.split(';base64,').pop() as string;
    const { fs, path, getPath } = ElectronApi;
    if (!fs || !path) throw '无法写入文件';
    const filename = path.join(
      await getPath('temp'),
      `${textToMd5(base64)}.${extension}`
    );
    await fs.promises.writeFile(filename, base64, {
      encoding: 'base64'
    });
    await action(filename);
    if (clear) await fs.promises.unlink(filename);
  } catch (err) {
    console.log(err);
  }
};
